import React from 'react';
import { trackCheckoutStart } from '../lib/metaPixel';
const CHECKOUT_URL = 'https://the-hands-off-hosting-system.impultienda.ar/checkout';
interface CtaButtonProps {
  label: string;
  className?: string;
  size?: 'md' | 'lg';
}
export function CtaButton({
  label,
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-7 py-4 text-sm sm:px-9 sm:text-base' : 'px-6 py-3 text-sm';
  return <a href={CHECKOUT_URL} onClick={trackCheckoutStart} className={`inline-flex items-center justify-center rounded-full bg-brand-gold font-body font-black uppercase tracking-[0.04em] text-brand-deep shadow-lg shadow-[#0d1a30]/25 transition duration-200 hover:-translate-y-0.5 hover:bg-[#dcae3c] hover:shadow-xl focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-gold/50 ${sizing} ${className}`} data-id="element-1" data-mp="qj93qvute79j">
      {label}
    </a>;
}